/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React from "react";
import AllReports from "../../../MiddleMileOperations/ExceptionReports/allReports";

const PincodeDiscrepanciesReport = () => {
    const embeddedId = "7ceb21d3-cc7b-4f56-841f-b9c724f3f203";
    const rsl = [];
    const title = "Pincode Discrepancies Report";
    
    return (
        <div>
            <AllReports embeddedId={embeddedId} rsl={rsl} title={title} />
        </div>
    );
};

export default PincodeDiscrepanciesReport; 
